module.exports = __webpack_public_path__ + "img/blogvisitedimage.91500ec3.jpg";